import { useMemo } from 'react';

import { GOLF_BALL_RADIUS } from './SceneComposition';

export const useBallOrigin = (ballTranslation: [number, number, number] | undefined) => {
    const originOffset: [number, number, number] = useMemo(() => {
        if (!ballTranslation) return [0, 0, 0];
        // Golf coords: [x=target, y=lateral, z=vertical]
        // Negate ball position to center skeleton on ball
        return [-ballTranslation[0], -ballTranslation[1], -ballTranslation[2] + GOLF_BALL_RADIUS];
    }, [ballTranslation]);
    return originOffset;
};
